import { Component, OnInit } from "@angular/core"
import { Location } from '@angular/common';
import { AppService } from '../../../app.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { FilterPipe } from '../pipes/filter.pipe';
import { CustomerService } from '../services/customer.service';
import { EquipmentService } from '../services/equipment.service';
import { Customer, Model, ComponentType, ModelSelected } from '../entities/global/model';
import { NewImplementTemplate, ImplementComponentType, TemplateAccess, ImplementCategory } from '../entities/implement-template.model';
import { ImplementTemplateService } from '../services/implement-template.service';
import { UserService } from '../services/user.service';
import { User, UserAccessLevelType } from '../entities/user.model';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
    selector: "implement-template-setup",
    templateUrl: './implement-template-setup.component.html',
    styleUrls: ['./implement-template-setup.component.scss']
})
export class ImplementTemplateSetupComponent {
    pageTitle: string = "Setup New Template";
    pageSubTitle: string = ""; 
    stepOne: FormGroup;
    stepTwo: FormGroup;
    customerList: Customer[];
    savingSchematic: boolean = false;

    modelList: ModelSelected[];
    modelListFiltered: ModelSelected[];
    selectedModels: number[];

    private readonly customerAccess = 'Customer';
    private readonly globalAccess = 'Global';

    componentTypeList: ComponentType[];
    componentTypeListFiltered: ComponentType[];

    selectAccess: string = this.customerAccess;
    selectGlobalAccessAllowed: boolean = false;

    selectCustomer: string;
    implementName: string;
    //selectModels: string;
    selectImplementType: string;
    componentTypesFilter: string;
    modelListFilter: string;
    newComponentName: string;

    selectedComponentTypesList: ComponentType[] = [];
    selectedImplementCategory: ImplementCategory;

    templateId: number;
    implementTemplateDetails: NewImplementTemplate;
    updateTemplate: boolean = false;

    // Loading Finished
    modelsLoaded: boolean = false;

    // Filter by selected or unselected.
    hideSelectedModels: boolean = false;
    hideUnselectedModels: boolean = false;
    hideSelectedMPs: boolean = false;
    hideUnselectedMPs: boolean = false;

    constructor(private route: ActivatedRoute, private _appService: AppService, private _customerService: CustomerService,
        private _equipmentService: EquipmentService, private _snackBar: MatSnackBar, private _formBuilder: FormBuilder,
        private _implementTemplateService: ImplementTemplateService, private _userService: UserService) { }

    ngOnInit() {
        this._appService.setPageTitle(this.pageTitle);
       // this._appService.setPageSubTitle(this.pageSubTitle);

        this._userService.loadUserDetails().subscribe(result => {
            this.selectGlobalAccessAllowed = result.AccessLevel == UserAccessLevelType.GlobalAdministrator ? true : false;
        }, error => { console.log(error); });

        this._customerService.getCustomerList().subscribe(result =>
        {
            this.customerList = result;

            // Need to get the models first before loading selections.
            this._equipmentService.getModelList().subscribe(result => {
                this.modelList = result;
                this.modelListFiltered = result;
                this.modelsLoaded = true;

                this.reloadDetails();
            }); 
        });
        
        this.stepOne = this._formBuilder.group({
            selectAccess: ['', Validators.required],
            selectCustomer: ['', Validators.required],
            selectImplementType: ['', Validators.required]
        });

        this.stepTwo = this._formBuilder.group({
            implementName: ['', Validators.required],
            selectModels: Validators.required,
            componentTypesFilter: new FormControl(),
            newComponentName: new FormControl(),
            modelListFilter: new FormControl()
        });

        this.implementTemplateDetails = new NewImplementTemplate();
    }

    reloadDetails() {
        this.route.params.subscribe(params => {
            this.templateId = +params['templateId'];

            if ((this.templateId != null) && (!isNaN(this.templateId))) {
                this._implementTemplateService.getTemplateDetails(this.templateId).subscribe(response => {
                    this.implementTemplateDetails = response;

                    if (this.implementTemplateDetails != null) {

                        // Mark this as an existing template that requires the update action.
                        this.updateTemplate = true;

                        // Access level (Global or Customer) and customer Id
                        if ((this.implementTemplateDetails.CustomerId != null) && (this.implementTemplateDetails.TemplateAccess == TemplateAccess.Customer)) {
                            this.selectAccess = this.customerAccess;
                            this.setCustomerRequired(true);

                            for (var i = 0; i < this.customerList.length; i++) {
                                if (this.customerList[i].Id == this.implementTemplateDetails.CustomerId) {
                                    this.selectCustomer = this.customerList[i].Id.toString();
                                    break;
                                }
                            }
                            
                        } else {
                            this.selectAccess = this.globalAccess;
                            this.setCustomerRequired(false);
                        }

                        // Implement category (GET or Dump Body)
                        if (this.implementTemplateDetails.ImplementCategory != null) {
                            if (this.implementTemplateDetails.ImplementCategory == ImplementCategory.GET) {
                                this.selectImplementType = "GET";
                                this.loadGetComponentTypes();
                            }
                            else if (this.implementTemplateDetails.ImplementCategory == ImplementCategory.DumpBody) {
                                this.selectImplementType = "Dump Body";
                                this.loadDumpBodyComponentTypes();
                            }
                        }

                        // Implement name
                        if (this.implementTemplateDetails.TemplateName != null) {
                            this.implementName = this.implementTemplateDetails.TemplateName;
                        }

                        // Supported equipment models
                        if (this.implementTemplateDetails.EquipmentModels != null) {
                            this.selectedModels = this.implementTemplateDetails.EquipmentModels;

                            for (var i = 0; i < this.selectedModels.length; i++) {
                                for (var j = 0; j < this.modelListFiltered.length; j++) {
                                    if (this.modelListFiltered[j].Id == this.selectedModels[i]) {
                                        this.modelListFiltered[j].Selected = true;
                                        break;
                                    }
                                }
                            }       
                        } 
                    }
                });
            }
        });
    }

    preLoadComponentTypesSelected() {
        // Component type list
        if (this.implementTemplateDetails.ComponentTypes != null) {

            for (var i = 0; i < this.implementTemplateDetails.ComponentTypes.length; i++) {
                // Add to the list of selected component types
                var newImplementComponentType = new ComponentType();
                newImplementComponentType.Id = this.implementTemplateDetails.ComponentTypes[i].Id;
                newImplementComponentType.Name = this.implementTemplateDetails.ComponentTypes[i].Name;
                newImplementComponentType.Selected = true;
                this.selectedComponentTypesList.push(newImplementComponentType);

                // Mark the selected components in the filtered list.
                for (var j = 0; j < this.componentTypeListFiltered.length; j++) {
                    if (this.componentTypeListFiltered[j].Id == this.implementTemplateDetails.ComponentTypes[i].Id) {
                        this.componentTypeListFiltered[j].Selected = true;
                        break;
                    }
                }
            }
        }
    }

    setCustomerRequired(required: boolean) {
        if (required) {
            this.selectAccess = this.customerAccess;
            this.stepOne.controls['selectCustomer'].setValidators([Validators.required]);
        }
        else {
            this.selectAccess = this.globalAccess;
            this.stepOne.controls['selectCustomer'].clearValidators();
        }

        this.stepOne.controls['selectCustomer'].updateValueAndValidity();
    }

    loadGetComponentTypes() {
        this.selectedImplementCategory = ImplementCategory.GET; // System Id of GET Component Types
        this._equipmentService.getGetComponentTypeList().subscribe(result => {
            this.componentTypeList = result;
            this.componentTypeListFiltered = result;
            this.selectedComponentTypesList = [];

            this.preLoadComponentTypesSelected();
        });
    }

    loadDumpBodyComponentTypes() {
        this.selectedImplementCategory = ImplementCategory.DumpBody; // System Id of Dump Body Component Types
        this._equipmentService.getDumpBodyComponentTypeList().subscribe(result => {
            this.componentTypeList = result;
            this.componentTypeListFiltered = result;
            this.selectedComponentTypesList = [];

            this.preLoadComponentTypesSelected();
        });
    }

    addNewComponent(scrollTarget) {
        if (this.newComponentName.length < 1)
            return;
        if (this.componentTypeList.filter(type => type.Name.toLowerCase() == this.newComponentName.toLowerCase()).length > 0) {
            this._snackBar.open('This component type already exists!', null, {
                duration: 1000,
            });
        } else {
            let newComponent: ComponentType = {
                Id: 0,
                Name: this.newComponentName,
                Selected: true
            };
            this.componentTypeList.push(newComponent);
            this.componentTypesFilter = '';
            this.componentTypeListFiltered = this.componentTypeList;
            scrollTarget.scrollIntoView({ behavior: "smooth" });
            this.newComponentName = '';
            this.selectedComponentTypesList.push(newComponent);
        }
    }

    onComponentTypeListControlChanged(id, name) {
        var ct = this.componentTypeList.find(ct => ct.Id == id && ct.Name == name);
        if (ct != null) {
            ct.Selected = !ct.Selected;
        }

        this.selectedComponentTypesList = this.componentTypeList.filter(c => c.Selected).map(item => {
            let comp: ComponentType = {
                Id: item.Id,
                Name: item.Name,
                Selected: item.Selected
            }
            return comp;
        });
    }

    onComponentTypeListFilterChange() {
        this.componentTypeListFiltered = this.componentTypeList.filter(item => item.Name.toLowerCase().includes(this.componentTypesFilter.toLowerCase()) ? true : false)
    }

    onModelListControlChanged(id) {
        var mt = this.modelList.find(m => m.Id == id);
        if (mt != null) {
            mt.Selected = !mt.Selected;
        }

        this.selectedModels = this.modelList.filter(m => m.Selected).map(item => item.Id);
    }

    onModelListFilterChange() {
        this.modelListFiltered = this.modelList.filter(item => item.Name.toLowerCase().includes(this.modelListFilter.toLowerCase()) ? true : false)
    }

    onSaveClick() {
        if (this.savingSchematic)
            return

        let template: NewImplementTemplate = {
            TemplateId: this.templateId ? this.templateId : 0,
            TemplateAccess: this.selectAccess == this.customerAccess ? TemplateAccess.Customer : TemplateAccess.Global,
            CustomerId: this.selectAccess == this.customerAccess ? Number(this.selectCustomer) : null,
            ImplementCategory: this.selectedImplementCategory,
            ComponentTypes: this.selectedComponentTypesList,
            EquipmentModels: this.selectedModels,
            TemplateName: this.implementName
        }

        if (!this.validateSubmission(template))
            return false;

        this.savingSchematic = true;

        if (!this.updateTemplate) {
            this._implementTemplateService.createNewImplementTemplate(template).subscribe(response => {
                window.location.href = response;
            })
        }
        else {
            this._implementTemplateService.updateExistingImplementTemplate(template).subscribe(response => {
                window.location.href = response;
            })
        }
    }

    validateSubmission(template: NewImplementTemplate): boolean {
        if (template.TemplateName == null || template.TemplateName == '') {
            this._snackBar.open('Please enter a name for this template. ', null, {
                duration: 1000,
            });
            return false;
        }

        if (template.ComponentTypes == null || template.ComponentTypes.length == 0) {
            this._snackBar.open('Please select at least 1 component for this template. ', null, {
                duration: 1000,
            });
            return false;
        }

        if (template.EquipmentModels == null || template.EquipmentModels.length == 0) {
            this._snackBar.open('Please select at least 1 model for this template. ', null, {
                duration: 1000,
            });
            return false;
        }

        return true;
    }


    // Toggle filters
    toggleSelectedModels() {
        this.hideSelectedModels = !this.hideSelectedModels;
    }

    toggleUnselectedModels() {
        this.hideUnselectedModels = !this.hideUnselectedModels;
    }

    toggleSelectedMPs() {
        this.hideSelectedMPs = !this.hideSelectedMPs;
    }

    toggleUnselectedMPs() {
        this.hideUnselectedMPs = !this.hideUnselectedMPs;
    }

    selectionLogicForModels(isSelected: boolean): boolean {
        if ((!this.hideSelectedModels && !this.hideUnselectedModels)
            || (!this.hideSelectedModels && isSelected && this.hideUnselectedModels)
            || (!this.hideUnselectedModels && !isSelected && this.hideSelectedModels)) {
            return true;
        } else {
            return false;
        }
    }

    selectionLogicForMPs(isSelected: boolean): boolean {
        if ((!this.hideSelectedMPs && !this.hideUnselectedMPs)
            || (!this.hideSelectedMPs && isSelected && this.hideUnselectedMPs)
            || (!this.hideUnselectedMPs && !isSelected && this.hideSelectedMPs)) {
            return true;
        } else {
            return false;
        }
    }
}
